//--- 🌐 Imports --------------------------
import $ from 'jquery';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
import Splide from '@splidejs/splide';
import lazySizes from 'lazysizes';
import EmblaCarousel from 'embla-carousel';

//--- 🧠 Variables ------------------------
const $d = $(document);
const $w = $(window);

//--- 🚀 Swup Setup -----------------------
const swup = new Swup({
  plugins: [
    new SwupBodyClassPlugin(),
    new SwupScrollPlugin({
      doScrollingRightAway: false,
      animateScroll: true,
      scrollFriction: 0.3,
      scrollAcceleration: 0.04
    })
  ]
});

//--- 🎯 Utility --------------------------
function l(m) {
  console.log(m);
}

//--- 💡 Init ----------------------------
function init() {
  if (!document.body) {
    console.warn('init() called before DOM is ready, deferring...');
    setTimeout(init, 10);
    return;
  }

  let header_color = $('main').data('header');

  // Initialize Embla Carousels
  initEmblaCarousels();

  if (header_color == 'header--white') {
    headerWhite();
  } else {
    headerBlack();
  }

  let elms = document.getElementsByClassName('splide');
  for (let i = 0; i < elms.length; i++) {
    if (elms[i].splide) continue;
    try {
      new Splide(elms[i], {
        autoplay: true,
        arrows: false,
        rewind: true,
        interval: 5000,
        perPage: 1,
        perMove: 1,
        gap: 0,
        padding: 0,
        heightRatio: 0,
        fixedHeight: 0
      }).mount();
    } catch (error) {
      console.error('Error initializing Splide:', error);
    }
  }

  checkSplash();
}

//--- 🍪 Cookie & Splash ------------------
function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  $('.cookie').addClass('hidden');
}

function checkCookie() {
  l('check cookie');
  document.cookie.indexOf('cookie-note=1') !== -1
    ? $('.cookie').addClass('hidden')
    : $('.cookie').removeClass('hidden');

  document.cookie.indexOf('cookie-form=1') !== -1
    ? $('.overlay').addClass('hidden')
    : $('.overlay').removeClass('hidden');
}

function checkSplash() {
  if (!sessionStorage.getItem('first-run')) {
    hideSplash();
    sessionStorage.setItem('first-run', true);
    l('first ran');
  } else {
    $('.splash').remove();
    l('already ran');
  }
}

function hideSplash() {
  $('.splash video').on('ended', function () {
    $('.splash').addClass('bye');
    setTimeout(() => $('.splash').remove(), 200);
  });
}

//--- 🧭 Header ---------------------------
function headerBGWhite() {
  $('header').addClass('header--bg-white');
}

function headerBGTransparent() {
  $('header').removeClass('header--bg-white');
}

function headerWhite() {
  $('header').addClass('header--white');
}

function headerBlack() {
  $('header').removeClass('header--white');
}

function headerCheck() {
  $(document).scrollTop() > 20 ? headerBGWhite() : headerBGTransparent();
}

//--- 📂 Navigation & UI ------------------
function dropDownShow() {
  try {
    $('ul.active').removeClass('active');
    $('.nav__dropdown-trig').removeClass('active');
    const $nextUl = $(this).next('ul');
    if ($nextUl.length > 0) $nextUl.addClass('active');
    $(this).addClass('active');
  } catch (e) {
    console.error('Error in dropDownShow:', e);
  }
}

function dropDownClose() {
  try {
    $('.nav__dropdown-trig').removeClass('active');
    $('ul.active').removeClass('active');
  } catch (e) {
    console.error('Error in dropDownClose:', e);
  }
}

function monavToggle() {
  $('body').toggleClass('monav-open');
}

function monavDropDownToggle() {
  const $nextUl = $(this).next('ul');
  if ($nextUl.length > 0) $nextUl.toggleClass('active');
  $(this).toggleClass('active');
}

//--- 🧍 Team Interactions ----------------
function flipOn() {
  $(this).removeClass('flip-off').addClass('flip-on');
}

function flipOff() {
  $(this).removeClass('flip-on').addClass('flip-off');
}

//--- 📦 Accordion / Category Filters -----
function accordionToggle() {
  $(this).parent('.accordion').toggleClass('open');
}

function catOn() {
  $('.button--cat').removeClass('on');
  $(this).addClass('on');
  let cat = $(this).data('cat');
  $('.filter-grid')
    .removeClass(
      'show-public-affairs-regulatory show-campaigning show-financial-communications show-all'
    )
    .addClass('show-' + cat);
  $('.team__item').addClass('visible');
  l(cat);
}

//--- 🪟 Modal ----------------------------
function modalShow() {
  console.log('Modal clicked', $(this).data('slug'));

  let slug = $(this).data('slug');
  console.log('Opening modal:', slug);
  $('body').css('overflow', 'hidden');
  $('.' + slug).addClass('on');
}

function modalClose() {
  $('body').css('overflow', 'visible');
  $('.modal').removeClass('on');
}

//--- 🎚️ Embla Carousel ------------------

// Store Embla instances globally
const emblaInstances = new Map();

function initEmblaCarousels() {
  const emblaNodes = document.querySelectorAll('.slider');

  emblaNodes.forEach((emblaNode) => {
    const viewportNode = emblaNode.querySelector('.slider__track');
    const controlInput = emblaNode.querySelector('.slider__control input');

    if (!viewportNode) return;

    const options = {
      align: 'start',
      containScroll: 'trimSnaps',
      dragFree: false,
      slidesToScroll: 1
    };

    const embla = EmblaCarousel(viewportNode, options);
    emblaInstances.set(emblaNode, embla);

    // Update range input when carousel scrolls
    const updateRangeInput = () => {
      if (!controlInput) return;
      const scrollProgress = Math.max(0, Math.min(1, embla.scrollProgress()));
      const percentage = Math.round(scrollProgress * 100);
      controlInput.value = percentage;
    };

    // Handle range input changes
    if (controlInput) {
      controlInput.addEventListener('input', () => {
        const target = parseFloat(controlInput.value) / 100;
        embla.scrollTo(Math.round(embla.scrollSnapList().length * target));
      });
    }

    embla.on('scroll', updateRangeInput);
    embla.on('init', updateRangeInput);
  });
}

// Clean up old slider functions (kept for backwards compatibility if needed)
function sliderMove() {
  let move = $(this).val();
  let sliderNode = $(this).parents('.slider')[0];
  const embla = emblaInstances.get(sliderNode);

  if (embla) {
    const target = parseFloat(move) / 100;
    embla.scrollTo(Math.round(embla.scrollSnapList().length * target));
  }
}

//--- 🎥 Video Button ---------------------
function videoToggle() {
  let container = $(this).parents('.circle-button');
  let video = container.find('video')[0];
  let cover = container.find('.circle-button__cover');
  let dot = container.find('.circle-button__dot');
  let text = container.find('.circle-button__text');

  if (video) {
    dot.addClass('bye');
    text.hide();
    cover.fadeOut();
    video.play();
  }
}

//--- 📤 Form Click -----------------------
$d.on('click', 'input.button', function () {
  l('form clicked');
  // e.preventDefault(); // Uncomment to prevent submission
});

//--- 🔗 Event Bindings -------------------
$d.on('click', '.cookie_btn', setCookie);
$d.on('mouseenter', '.nav__dropdown-trig', dropDownShow);
$d.on('mouseleave', 'header', dropDownClose);
$d.on('mouseenter', '.team__item a', flipOn);
$d.on('mouseleave', '.team__item a', flipOff);
$d.on('click', '.accordion__button', accordionToggle);
$d.on('click', '.filter-button', catOn);
$d.on('click', '.team__card-contact a', function(e) {
  e.stopPropagation(); // Prevent modal from opening when clicking email/LinkedIn
});
$d.on('click', '.team__grid--big a', modalShow);
$d.on('click', '.modal__bg, .modal__close', modalClose);
$d.on('input', '.slider__control input', sliderMove);
$d.on('scroll', headerCheck);
$d.on('click', '.monav__button', monavToggle);
$d.on('click', '.monav__dropdown-trig', monavDropDownToggle);
$d.on('click', '.circle-button__dot', videoToggle);

//--- 📦 Page Lifecycle -------------------
document.addEventListener('DOMContentLoaded', () => {
  l('ready');
  checkCookie();
  init();
});

swup.hooks.on('content:replace', () => {
  init();
  if (window.lazySizes) {
    lazySizes.init();
  }
});